import React, { useState } from "react";
var axios = require("axios").default;

const AppTwo = () => {
  const [continent, setContinent] = useState();
  const [time, setTime] = useState();
  const [weather, setWeather] = useState();

  var options = {
    method: "GET",
    url: "https://weatherapi-com.p.rapidapi.com/ip.json",
    params: { q: "auto:ip" },
    headers: {
      "x-rapidapi-host": "weatherapi-com.p.rapidapi.com",
      "x-rapidapi-key": "c1d4bd538dmsh760aacb9e8e1ef3p161128jsn0aa0b306fa8e"
    }
  };

  var weatherOptions = {
    method: "GET",
    url: "https://weatherapi-com.p.rapidapi.com/current.json",
    params: { q: "q=auto:ip IP" },
    headers: {
      "x-rapidapi-host": "weatherapi-com.p.rapidapi.com",
      "x-rapidapi-key": "c1d4bd538dmsh760aacb9e8e1ef3p161128jsn0aa0b306fa8e"
    }
  };

  axios
    .request(options)
    .then(function (response) {
      //console.log(response.data);
      let data = response.data;
      setContinent(data.continent_name);
      setTime(data.localtime);
    })
    .catch(function (error) {
      console.error(error);
    });

  axios
    .request(weatherOptions)
    .then(function (response) {
      //console.log(response.data);
      let data = response.data;
      setWeather(data.current.temp_f);
    })
    .catch(function (error) {
      console.error(error);
    });

  return (
    <>
      <p>Visiting from {continent}!</p>
      <p>The date is {time}</p>
      <p>and it's {weather} degrees farenheit</p>
    </>
  );
};

export default AppTwo;
